module.exports = __webpack_public_path__ + "static/media/ES.e15294f9.svg";